import { trovaPerRoute, type RisultatoRicerca, type VoceMenu } from "~/utils/menu";

// Accesso al menu del ruolo dell'utente (store `auth`): lettura (getMenu) e ricerca ricorsiva, a qualsiasi profondità, di una voce
// a partire dalla sua route (findByRoute: { item, antenati } oppure null). Se non si passa una lista si usa il menu dell'utente.
export const useMenuLookup = () => {
  const auth = useAuthStore();

  const getMenu = (): VoceMenu[] => auth.menu;

  const findByRoute = (route: string, lista: VoceMenu[] = getMenu()): { item: VoceMenu; antenati: VoceMenu[] } | null => {
    const trovata: RisultatoRicerca | null = trovaPerRoute(route, lista);
    return trovata ? { item: trovata.voce, antenati: trovata.antenati } : null;
  };

  return { getMenu, findByRoute };
};
